import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption, IRoleEnum } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IRoleEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.userRoles");

export const userRoles = {
  ...getAllApis,
};
